import { FC } from 'react';

import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Section from 'components/Section';
import TwoColumn from 'components/TwoColumn';
import Checkbox from 'components/Checkbox';

const GeneralSettingsEditFormSystem: FC = () => (
  <Section id="system" title="Sistema">
    <Stack>
      <TwoColumn
        left={
          <FormControlLabel
            label="Debug režimas"
            control={<Checkbox name="debugMode" />}
          />
        }
        right={
          <FormControlLabel
            label="Profiliavimas"
            control={<Checkbox name="profiler" />}
          />
        }
      />
    </Stack>
  </Section>
);

export default GeneralSettingsEditFormSystem;
